
import { mapActions, mapState } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mdiArrowRight, mdiCalendar, mdiHandPointingRight, mdiRvTruck, mdiTruckTrailer } from '@mdi/js'
import eav from '@/components/tools/eav'

import time from '@/components/tools/time'
import LandingMyAdItem from '@/components/landing/LandingMyAdItem.vue'
import VuetifyMoney from '@/components/ui/VuetifyMoney.vue'
import constants from '@/components/tools/constants'
import tracking from '@/components/tools/tracking'

export default {
  components: {
    VuetifyMoney,
    ValidationObserver,
    ValidationProvider,
    LandingMyAdItem
  },
  props: {
    createNew: {
      type: Boolean,
      default: false
    },

    section: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      mdiHandPointingRight,
      mdiRvTruck,
      mdiTruckTrailer,
      mdiCalendar,
      mdiArrowRight,
      loading: false
    }
  },
  async fetch () {
    await Promise.all([
      this.createNew ? this.getEmptyProduct() : this.getOnboardingStepperData({}),
      this.getAttributes(),
      this.getAttributesDe(),
      this.getProductTypeOptionIds()
    ])
  },

  computed: {
    ...mapState('customer', ['merchant']),
    isMerchant () {
      return typeof this.merchant?.merchantId === 'number'
    },
    widthDialog () {
      if (this.$vuetify.breakpoint.mobile) {
        return '90vw'
      } else {
        return '40vw'
      }
    },
    ...mapState('upload', {
      product: state => state.product,
      attributes: state => state.attributes,
      productTypeOptionIds: state => state.productTypeOptionIds

    }),
    entityId () {
      return this.product.entityId
    },
    status () {
      return this.product?.auction?.status
    },
    showStepper () {
      return this.product?.entityId === null
    },

    ctaText () {
      return this.$t('onboarding.cta.ad.else')
    },

    pending () {
      return this.$fetchState.pending
    },

    productTypeValue: {
      get () {
        return eav.getEavAttribute(
          'product_type',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'product_type',
          value
        })
      }
    },
    licencePlateIcon () {
      if (this.isTrailer) {
        return mdiTruckTrailer
      }

      return mdiRvTruck
    },
    productTypeLabel () {
      return this.attributes.product_type?.label
    },
    productTypeItems () {
      if (this.section.disabledProductType) {
        const that = this
        return this.attributes.product_type?.options.map((item) => {
          if (that.productTypeOptionIds.trailer === item.optionId && that.section.disabledProductType === 'trailer') {
            item.disabled = true
          } else if (that.productTypeOptionIds.motorhome === item.optionId && that.section.disabledProductType === 'motorhome') {
            item.disabled = true
          }

          return item
        })
      }

      return this.attributes.product_type?.options
    },
    isTrailer () {
      return (
        this.productTypeValue?.optionId === this.productTypeOptionIds.trailer
      )
    },

    licensePlateValue: {
      get () {
        return eav.getEavAttribute(
          'license_plate',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'license_plate',
          value
        })
      }
    },
    targetPriceValue: {
      get () {
        return this.product?.auction?.targetPrice
      },
      set (value) {
        this.editing = 'target_price'
        this.$store.dispatch('upload/setSimpleAuctionAttribute', {
          attributeCode: 'targetPrice',
          value
        })
        this.$store.dispatch('upload/setSimpleAuctionAttribute', {
          attributeCode: 'buyNowPrice',
          value
        })
      }
    },

    licensePlateLabel () {
      return this.attributes.license_plate?.label
    },
    targetPriceLabel () {
      return this.attributes.target_price?.label
    }

  },
  mounted () {

  },

  methods: {
    ...mapActions('general', ['showSnackbar']),
    ...mapActions('customer', ['getAds']),
    ...mapActions('upload', [
      'getOnboardingStepperData',
      'getProduct',
      'getEmptyProduct',
      'getProductTypeOptionIds',
      'getAttributes',
      'getAttributesDe',
      'createProduct',
      'updateProduct'
    ]),

    blurTargetPrice (value) {
      if (value >= 1000) {
        this.targetPriceValue = Math.ceil(value / 100) * 100
      }
    },

    async getAdsFromApi () {
      const page = 1

      this.loading = true
      await this.getAds(page)
    },

    endingAt (product) {
      return time.parseDate(product.auction?.endingAt)
    },

    async justGoToAdIntake () {
      const { status, data } = await this.createProduct(
        {
          source: tracking.getSource(this.source, this.$route),
          sourceUrl: this.$route.path,
          funnel: constants.TP.FUNNEL.AD_INTAKE
        }

      )
      if (status !== 200) {
        await this.showSnackbar({
          text: this.$t('error'),
          color: 'error'
        })
        return
      }

      await this.$router.push(
        this.localePath({
          name: `ad-edit-${data.productType}-profile-id`,
          params: { id: data.entityId }
        })
      )
    },

    async fetchFromRdwAndGoToAdIntake () {
      const { status, data } = await this.createProduct({
        source: tracking.getSource(this.source, this.$route),
        sourceUrl: this.$route.path,
        funnel: constants.TP.FUNNEL.AD_INTAKE
      })
      if (status !== 200) {
        await this.showSnackbar({
          text: this.$t('error'),
          color: 'error'
        })
        return
      }

      // this.rdwFetchDialog = true
      const { data: fetchedFromRdw } = await this.fetchFromRdw(data.entityId, this.licensePlateValue)
      const success = fetchedFromRdw.success
      const productType = fetchedFromRdw.productDto.productType

      if (success) {
        // eslint-disable-next-line promise/param-names
        await new Promise(r => setTimeout(r, 5000))
        await this.$router.push(
          this.localePath({
            name: `ad-edit-${productType}-profile-id`,
            params: { id: data.entityId }
          })
        )
      } else {
        // this.rdwFetchDialogShowCouldNotFetch = true
        // eslint-disable-next-line promise/param-names
        // await new Promise(r => setTimeout(r, 5000))
        await this.$router.push(
          this.localePath({
            name: `ad-edit-${productType}-profile-id`,
            params: { id: data.entityId },
            query: { error: 'licensePlateNotRecognized' }
          })
        )
      }
    },
    fetchFromRdw (entityId, licensePlate) {
      const url = this.$auth.loggedIn ? `/private/product/update-from-rdw/${entityId}` : `/public/product/update-from-rdw/${entityId}`
      return this.$axios.post(url, { licensePlate }, { withCredentials: true })
    },
    async submit () {
      this.loading = true

      await this.fetchFromRdwAndGoToAdIntake()

      this.loading = false

      try {
        this.$refs.observer.reset()
      } catch (e) {

      }
    }

  }
}
